import { useFormikContext } from 'formik'
import { RemixButton as Button } from 'ui-components'

function RemixButton() {
  const formik = useFormikContext()

  return (
    <Button
      loading={formik.isSubmitting}
      type='submit'
      disabled={!formik.isValid}
    />
  )
}

export { RemixButton }
